import React from 'react';
import styled from 'styled-components';
import useContentAsociacionUsuarios from '../hooks/parameter/useContentAsociacionUsuarios';
import useContentHumanizacion from '../hooks/parameter/useContentHumanizacion';
import ContentLoader from 'react-content-loader';

const DivContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  width: 100%;
  max-width: 1200px;

  p {
    text-align: center;
    padding: 2rem 5rem;

    img {
      margin-top: 2.5rem;
      width: 100% !important;
    }
  }
`;

export const PageHumanizacion = () => {
  window.scroll(0, 0);

  const { contentHumanizacion, isLoadingHumanizacion } =
    useContentHumanizacion();
  const bodyHTML =
    contentHumanizacion.length > 0 && contentHumanizacion[0].texto_completo;

  return (
    <>
      <div
        style={{
          display: 'flex',
          justifyContent: 'center',
        }}
      >
        <DivContainer id='contBodyHTML'>
          {isLoadingHumanizacion ? (
            <div>
              <ContentLoader
                speed={2}
                width='80%'
                height={450}
                backgroundColor='#05AAAA'
              />
            </div>
          ) : (
            <p dangerouslySetInnerHTML={{ __html: bodyHTML }} />
          )}
        </DivContainer>
      </div>
    </>
  );
};
